<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      lock-scroll
      close-on-popstate
      :style="{ height: '100%', width:'100%' }"
    >
      <ld-header
        @click-left="isShow = false"
        @click-right="complie"
      >
        <span
          slot="right"
          class="main-color"
        >
          {{ $t('B010','保存') }}
        </span>
      
        编辑个人信息
      </ld-header>
    
      <van-cell
        :title="$t('D017','国籍')"
        @click="$refs.nation.toggle()"
        :value="nationName"
        is-link
      />

      <ld-nation
        ref="nation"
        @selected="nationSelect"
      />
    </van-popup>
  </div>
</template>

<script>
import mixin from './mixin'
import ldNation from 'Components/ldNation'

export default {
  name: 'EditNation',
  components: {
    ldNation
  },
  mixins: [mixin],
  data() {
    return {
      nation: '',
      nationName: ''
    }
  },
  created () {
    this.nation = this.empInfo.nation
    this.nationName = this.empInfo.nationName
  },
  methods: {
    nationSelect (nation) {
      this.nation = nation.id
      this.nationName = nation.cName
    },
    complie () {
      this.empInfo.nation = this.nation
      this.empInfo.nationName = this.nationName
      this.save()
    }
  }
}
</script>